import { Route, Routes } from "@angular/router";
import { GetAnfrageValidationErrorsResolver } from "../resolver/anfrage/get-anfrage-validationerrors.resolver";
import { GetAnfrageContactDataResolver } from "../resolver/anfrage/get-anfrage-contact-data.resolver";
import { FragenProcessStepComponent } from "../features/anfrage/forms/fragen-process-step/fragen-process-step.component";
import { FragenResolver } from "../resolver/fragen/fragen.resolver";
import { AttachmentsProcessStepComponent } from "../features/anfrage/forms/attachments-process-step/attachments-process-step.component";
import { MilestonesProcessStepComponent } from "../features/anfrage/forms/milestones-process-step/milestones-process-step.component";
import { GetAnfrageReportDocumenttypesResolver } from "../resolver/report/get-anfrage-report-documenttypes.resolver";
import { GetAnfrageReportAttachmentsResolver } from "../resolver/report/get-anfrage-report-attachments.resolver";
import { GetAnfrageReportMilestonesDataResolver } from "../resolver/report/get-anfrage-report-milestones.resolver";
import { AnfrageReportDetailComponent } from "../features/reports/anfrage-report-detail/anfrage-report-detail.component";
import { GetAnfrageReportByIdResolver } from "../resolver/report/get-anfrage-report-by-id.resolver";
import { BaseRoutingFactory } from "./base-routing.factory";
import { DataprotectionProcessStepComponent } from "../forms/dataprotection-process-step/dataprotection-process-step.component";
import { UserModelResolver } from "../resolver/user/user-model.resolver";
import { CanDeactivateGuard } from "../guards/can-deactivate.guard";
import { UebersichtDataComponent } from "../forms/uebersicht-data/uebersicht-data.component";
import { GetAnfrageuebersichtDataResolver } from "../resolver/anfrage/get-anfrageuebersicht-data.resolver";
import { InformationenProcessStepComponent } from "../features/anfrage/forms/informationen-process-step/informationen-process-step.component";

export class ReportRoutingFactory extends BaseRoutingFactory {
    private readonly coreReportRoute: Routes = [
        {
            path: ':scope/:id/:reportid',
            component: this.componentService.get(AnfrageReportDetailComponent),
            data: { useAnfrageLanguage: true },
            resolve: {
                anfrage: this.componentService.get(GetAnfrageReportByIdResolver)
            },
            children: [
                {
                    path: 'attachments/:abschnittid',
                    component: this.componentService.get(AttachmentsProcessStepComponent),
                    resolve: {
                        contactData: this.componentService.get(GetAnfrageContactDataResolver),
                        documenttypes: this.componentService.get(GetAnfrageReportDocumenttypesResolver),
                        attachments: this.componentService.get(GetAnfrageReportAttachmentsResolver),
                        userModel: this.componentService.get(UserModelResolver),
                    },
                    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
                },
                {
                    path: 'milestones/:abschnittid',
                    component: this.componentService.get(MilestonesProcessStepComponent),
                    canDeactivate: [CanDeactivateGuard],
                    resolve: {
                        milestones: this.componentService.get(GetAnfrageReportMilestonesDataResolver)
                    }
                },
                {
                    path: 'questions/:abschnittid',
                    component: this.componentService.get(FragenProcessStepComponent),
                    resolve: {
                        fragen: this.componentService.get(FragenResolver)
                    },
                    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
                },
                {
                    path: 'information/:abschnittid',
                    component: this.componentService.get(InformationenProcessStepComponent),
                },
                {
                    path: 'dataprotection',
                    component: this.componentService.get(DataprotectionProcessStepComponent),
                    resolve: {
                        errors: this.componentService.get(GetAnfrageValidationErrorsResolver)
                    },
                },
                {
                    path: 'uebersicht-data/:abschnittid',
                    component: this.componentService.get(UebersichtDataComponent),
                    resolve: {
                        uebersicht: this.componentService.get(GetAnfrageuebersichtDataResolver),
                    },
                }
            ]
        }
    ];

    public create(): Routes {
        const coreRoute = this.coreRoute;

        return coreRoute;
    }

    protected get coreRoute(): Routes {
        return this.coreReportRoute;
    }

    protected registerChild(coreRoute: Routes, route: Route) {
        const formRoutes = coreRoute![0].children!;
        const foundIndex = formRoutes?.findIndex(formRoute => formRoute.path === route.path);
        if (foundIndex >= 0) {
            formRoutes[foundIndex] = route;
            return;
        }
        else {
            coreRoute![0].children!.push(route);
        }
    }
}